import { createMachine, assign, setup } from "xstate";
import { ExemptionQuestions } from "utils/types/exemption-questions";
import { commonGuards } from "./_commonGuards";
import moment from "moment";

const newYorkGuards: {
	[key: string]: (context: ExemptionQuestions.FlowContext) => boolean;
} = {
	isIncomeQualified: context =>
		!!context.specialFieldsValue?.income_tax_history?.[0]
			?.annual_household_income &&
		context.specialFieldsValue?.income_tax_history?.[0]
			?.annual_household_income < 500_000,
	// isTransferringStarCredit: context =>
	// 	context.specialFieldsValue?.transfer_star_credit === "yes",
};

export const newYorkExemptionQuestionFlowMachine = setup({
	types: {
		context: {} as ExemptionQuestions.FlowContext,
		events: {} as ExemptionQuestions.FlowEvent,
		input: {} as Partial<ExemptionQuestions.FlowContext>,
	},
	actions: {
		updateContext: assign(({ context, event }) => {
			if ("context" in event) {
				return {
					...context,
					...event.context,
				};
			}
			return context;
		}),
	},
	guards: {},
	delays: {},
}).createMachine({
	id: "NEW_YORK_EXEMPTION",
	context: ({ input }) => ({ ...input }) as ExemptionQuestions.FlowContext,
	initial: "IDLE",
	states: {
		IDLE: {},
		INIT: {
			always: [
				// {
				// 	target: "INTRO",
				// 	guard: ({ context, event }) => {
				// 		const url = new URL(window.location.href);

				// 		return (
				// 			context.primaryResidenceValue === undefined &&
				// 			url.searchParams.get("q") !== "primaryResidence"
				// 		);
				// 	},
				// },
				{
					target: "PRIMARY_RESIDENCE",
					guard: ({ context, event }) =>
						context.primaryResidenceValue === undefined,
				},
				{
					target: "CURRENTLY_RECEIVING",
					guard: ({ context, event }) => {
						return context.currentlyReceivingValue === undefined;
					},
				},
				// {
				// 	target: "TRANSFER_STAR_CREDIT",
				// 	guard: ({ context, event }) =>
				// 		!commonGuards.currentlyReceivingNoOrNotSure(context) &&
				// 		context.specialFieldsValue?.transfer_star_credit === undefined,
				// },
				// {
				// 	target: "PREVIOUS_RESIDENCE",
				// 	guard: ({ context, event }) =>
				// 		!commonGuards.currentlyReceivingNoOrNotSure(context) &&
				// 		[
				// 			context.previousAddressValue,
				// 			context.previousCityValue,
				// 			context.previousZipcodeValue,
				// 		].some(value => value === undefined),
				// },
				{
					target: "ANNUAL_HOUSEHOLD_INCOME",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						context.specialFieldsValue?.income_tax_history?.[0]
							?.annual_household_income === undefined,
				},
				{
					target: "PURCHASE_DATE",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.purchaseDateValue === undefined,
				},
				{
					target: "RARE_SITUATIONS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						[
							context.hasDisability === true,
							context.isVeteran === true,
							context.specialFieldsValue?.is_manufactured_home === undefined,
							context.specialFieldsValue?.is_active_duty_personnel ===
								undefined,
							context.noneOfTheAbove === undefined,
						].some(value => value === true),
				},
				{
					target: "HAS_PORTAL_ACCOUNT",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue?.has_ny_gov_id_account === undefined,
				},
				{
					target: "PORTAL_ACCOUNT_CREDENTIALS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue?.ny_gov_id_account_username_provided ===
							undefined &&
						context.specialFieldsValue?.ny_gov_id_account_password_provided ===
							undefined,
				},
				{
					target: "DOB",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.dobValue === undefined,
				},
				{
					target: "MARITAL_STATUS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.maritalStatusValue === undefined,
				},
				{
					target: "SSN_TIN",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.owner1HasEnteredSsnTin === undefined,
				},
				{
					target: "TAX_FILING_HISTORY",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner1
							?.federal_tax_return === undefined,
				},
				{
					target: "TAX_FILING_HISTORY_DETAILS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						!!context.specialFieldsValue?.income_tax_history?.[0]?.owner1 &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner1
							?.filing_status === undefined &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner1
							?.gross_income === undefined &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner1
							?.taxable_income === undefined &&
						(context.specialFieldsValue?.income_tax_history?.[0]?.owner1
							?.received_refund === undefined ||
							(context.specialFieldsValue?.income_tax_history?.[0]?.owner1
								?.received_refund === true &&
								context.specialFieldsValue?.income_tax_history?.[0]?.owner1
									?.refund_amount === undefined)) &&
						context.specialFieldsValue.income_tax_history?.[0].owner1
							.federal_tax_return === true,
				},
				{
					target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue
							?.filed_ny_state_tax_return_within_last_5_years === undefined,
				},
				{
					target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue
							?.filed_ny_state_tax_return_within_last_5_years === true &&
						context.specialFieldsValue?.most_recent_ny_state_tax_return ===
							undefined,
				},
				{
					target: "OWNERS",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.ownersValue === undefined,
				},
				{
					target: "ADDITIONAL_OWNER",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						!(
							commonGuards.isSoleOwner(context) &&
							context.maritalStatusValue === "Single"
						) &&
						context.owner2HasEnteredSsnTin === undefined &&
						[
							context.additionalOwnerFirstNameValue === undefined,
							context.additionalOwnerLastNameValue === undefined,
							context.additionalOwnerDobValue === undefined,
						].some(value => value === true),
				},
				{
					target: "TAX_FILING_HISTORY_2",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						!(
							commonGuards.isSoleOwner(context) &&
							context.maritalStatusValue === "Single"
						) &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.state === undefined,
				},
				{
					target: "TAX_FILING_HISTORY_DETAILS_2",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						!(
							commonGuards.isSoleOwner(context) &&
							context.maritalStatusValue === "Single"
						) &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.state === "NY" &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.filing_status === undefined &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.gross_income === undefined &&
						context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.taxable_income === undefined &&
						(context.specialFieldsValue?.income_tax_history?.[0]?.owner2
							?.received_refund === undefined ||
							(context.specialFieldsValue?.income_tax_history?.[0]?.owner2
								?.received_refund === true &&
								context.specialFieldsValue?.income_tax_history?.[0]?.owner2
									?.refund_amount === undefined)) &&
						["Federal Only", "State Only", "Federal and State"].includes(
							context.specialFieldsValue.income_tax_history?.[0].owner2
								.tax_return_type ?? ""
						),
				},
				{
					target: "TRUST_DOCUMENT_UPLOAD",
					guard: ({ context, event }) =>
						commonGuards.currentlyReceivingNoOrNotSure(context) &&
						newYorkGuards.isIncomeQualified(context) &&
						context.specialFieldsValue?.owned_by_trust === true &&
						context.specialFieldsValue?.trust_document_ref === undefined,
				},
				{
					target: "AGREEMENT",
					guard: ({ context, event }) =>
						[
							context.primaryResidenceValue === true,
							context.currentlyReceivingValue === "no" ||
								context.currentlyReceivingValue === "notSure",
						].every(value => value === true),
				},
			],
		},
		INTRO: {
			entry: [
				assign({
					exemptionsProgress: context => 0,
				}),
			],
			on: {
				next: {
					target: "PRIMARY_RESIDENCE",
				},
			},
		},
		PRIMARY_RESIDENCE: {
			entry: [
				assign({
					exemptionsProgress: context => 0,
				}),
			],
			on: {
				back: {
					target: "INTRO",
					actions: assign({
						primaryResidenceValue: context => undefined,
					}),
				},
				next: [
					{
						target: "CURRENTLY_RECEIVING",
						guard: ({ context, event }) =>
							commonGuards.isPrimaryResidence(context),
					},
					{
						target: "NON_AGREEMENT_CONFIRMATION",
						guard: ({ context, event }) =>
							commonGuards.isNotPrimaryResidence(context),
					},
				],
			},
		},
		NON_AGREEMENT_CONFIRMATION: {
			entry: [
				assign({
					exemptionsProgress: context => 100,
				}),
			],
		},
		CURRENTLY_RECEIVING: {
			entry: [
				assign({
					exemptionsProgress: context => (1 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "PRIMARY_RESIDENCE",
					actions: assign({
						currentlyReceivingValue: context => undefined,
					}),
				},
				next: [
					{
						target: "ANNUAL_HOUSEHOLD_INCOME",
						guard: ({ context, event }) =>
							commonGuards.currentlyReceivingNoOrNotSure(context),
					},
					{
						target: "NON_AGREEMENT_CONFIRMATION",
						guard: ({ context, event }) =>
							!commonGuards.currentlyReceivingNoOrNotSure(context),
					},
					// {
					// 	target: "TRANSFER_STAR_CREDIT",
					// 	cond: context =>
					// 		commonGuards.currentlyReceivingYesAtThisProperty(context) ||
					// 		commonGuards.currentlyReceivingYesAtAnotherProperty(context),
					// },
					// {
					// 	target: "ANNUAL_HOUSEHOLD_INCOME",
					// },
				],
			},
		},
		// TRANSFER_STAR_CREDIT: {
		// 	entry: [
		// 		assign({
		// 			exemptionsProgress: context => (1.25 / 14) * 100,
		// 		}),
		// 	],
		// 	on: {
		// 		back: {
		// 			target: "CURRENTLY_RECEIVING",
		// 			actions: assign({
		// 				specialFieldsValue: context => ({
		// 					...context.specialFieldsValue,
		// 					transfer_star_credit: undefined,
		// 				}),
		// 			}),
		// 		},
		// 		next: [
		// 			{
		// 				target: "PREVIOUS_RESIDENCE",
		// 				cond: context =>
		// 					context.specialFieldsValue?.transfer_star_credit === "yes",
		// 			},
		// 			{
		// 				target: "ANNUAL_HOUSEHOLD_INCOME",
		// 			},
		// 		],
		// 	},
		// },
		// PREVIOUS_RESIDENCE: {
		// 	entry: [
		// 		assign({
		// 			exemptionsProgress: context => (1.5 / 14) * 100,
		// 		}),
		// 	],
		// 	on: {
		// 		back: {
		// 			target: "TRANSFER_STAR_CREDIT",
		// 			actions: assign({
		// 				previousAddressValue: context => undefined,
		// 				previousAddress2Value: context => undefined,
		// 				previousCityValue: context => undefined,
		// 				previousStateValue: context => undefined,
		// 				previousZipcodeValue: context => undefined,
		// 				previousMoveOutDateValue: context => undefined,
		// 			}),
		// 		},
		// 		next: {
		// 			target: "ANNUAL_HOUSEHOLD_INCOME",
		// 		},
		// 	},
		// },
		ANNUAL_HOUSEHOLD_INCOME: {
			entry: [
				assign({
					exemptionsProgress: context => (2 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "CURRENTLY_RECEIVING",
						guard: ({ context, event }) =>
							commonGuards.currentlyReceivingNoOrNotSure(context),
						actions: assign({
							specialFieldsValue: ({ context, event }) => {
								const tax_history_item = {
									tax_year: undefined,
									annual_household_income: undefined,
									owner1: {
										filed: undefined,
										state: undefined,
										gross_income: undefined,
										filing_status: undefined,
									},
									owner2: {
										filed: undefined,
										state: undefined,
										gross_income: undefined,
										filing_status: undefined,
									},
								};
								return {
									...context.specialFieldsValue,
									income_tax_history: [tax_history_item],
								};
							},
						}),
					},
				],
				next: [
					{
						target: "PURCHASE_DATE",
						guard: ({ context, event }) =>
							newYorkGuards.isIncomeQualified(context),
					},
					{
						target: "NON_AGREEMENT_CONFIRMATION",
					},
				],
			},
		},
		PURCHASE_DATE: {
			entry: [
				assign({
					exemptionsProgress: context => (3 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "ANNUAL_HOUSEHOLD_INCOME",
					actions: assign({
						purchaseDateValue: context => undefined,
					}),
				},
				next: {
					target: "HOMESTEAD_QUALIFIED",
				},
			},
		},
		HOMESTEAD_QUALIFIED: {
			entry: [
				assign({
					exemptionsProgress: context => (4 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "PURCHASE_DATE",
				},
				next: {
					target: "RARE_SITUATIONS",
				},
			},
		},
		RARE_SITUATIONS: {
			entry: [
				assign({
					exemptionsProgress: context => (5 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "HOMESTEAD_QUALIFIED",
						actions: assign({
							hasDisability: context => undefined,
							isVeteran: context => undefined,
							noneOfTheAbove: context => undefined,
							ownedThroughCooperativeHousing: context => undefined,
							specialFieldsValue: ({ context, event }) => ({
								...context.specialFieldsValue,
								is_manufactured_home: undefined,
								is_active_duty_personnel: undefined,
							}),
						}),
					},
				],
				next: [
					{
						target: "NON_AGREEMENT_CONFIRMATION",
						guard: ({ context, event }) =>
							context.hasDisability === true || context.isVeteran === true,
					},
					{
						target: "HAS_PORTAL_ACCOUNT",
					},
				],
			},
		},
		HAS_PORTAL_ACCOUNT: {
			entry: [
				assign({
					exemptionsProgress: context => (6 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "RARE_SITUATIONS",
					actions: assign({
						specialFieldsValue: ({ context, event }) => ({
							...context.specialFieldsValue,
							has_ny_gov_id_account: undefined,
						}),
					}),
				},
				next: [
					{
						target: "PORTAL_ACCOUNT_CREDENTIALS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue?.has_ny_gov_id_account,
					},
					{
						target: "DOB",
					},
				],
			},
		},
		PORTAL_ACCOUNT_CREDENTIALS: {
			entry: [
				assign({
					exemptionsProgress: context => (6.5 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "HAS_PORTAL_ACCOUNT",
					actions: assign({
						nyGovIdAccountUsername: context => undefined,
						nyGovIdAccountPassword: context => undefined,
					}),
				},
				next: [
					{
						target: "NON_AGREEMENT_CONFIRMATION",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue
								?.does_not_want_to_provide_ny_gov_id_account_credentials,
					},
					{
						target: "DOB",
					},
				],
			},
		},
		DOB: {
			entry: [
				assign({
					exemptionsProgress: context => (6 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "PORTAL_ACCOUNT_CREDENTIALS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue?.has_ny_gov_id_account,
						actions: assign({
							dobValue: context => undefined,
						}),
					},
					{
						target: "HAS_PORTAL_ACCOUNT",
					},
				],
				next: [
					{
						target: "NON_AGREEMENT_CONFIRMATION",
						guard: ({ context, event }) =>
							moment().diff(context.dobValue, "years") >= 65 &&
							!!context.specialFieldsValue?.income_tax_history?.[0]
								?.annual_household_income &&
							context.specialFieldsValue?.income_tax_history?.[0]
								?.annual_household_income <= 93_200,
					},
					{
						target: "MARITAL_STATUS",
					},
				],
			},
		},
		MARITAL_STATUS: {
			entry: [
				assign({
					exemptionsProgress: context => (7 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "DOB",
					actions: assign({
						maritalStatusValue: context => undefined,
					}),
				},
				next: {
					target: "SSN_TIN",
				},
			},
		},

		SSN_TIN: {
			entry: [
				assign({
					exemptionsProgress: context => (8 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "MARITAL_STATUS",
					actions: assign({
						owner1SsnTin: context => undefined,
					}),
				},
				next: {
					target: "TAX_FILING_HISTORY",
				},
			},
		},
		TAX_FILING_HISTORY: {
			entry: [
				assign({
					exemptionsProgress: context => (9 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "SSN_TIN",
					actions: assign({
						specialFieldsValue: ({ context, event }) => {
							const tax_history_item = {
								...context.specialFieldsValue?.income_tax_history?.[0],
								owner1: {
									filed: undefined,
									state: undefined,
									gross_income: undefined,
									filing_status: undefined,
									tax_return_type: undefined,
								},
								owner2: {
									filed: undefined,
									state: undefined,
									gross_income: undefined,
									filing_status: undefined,
									tax_return_type: undefined,
								},
							};
							return {
								...context.specialFieldsValue,
								income_tax_history: [tax_history_item],
							};
						},
					}),
				},
				next: [
					{
						target: "TAX_FILING_HISTORY_DETAILS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue?.income_tax_history?.[0]?.owner1
								?.federal_tax_return,
					},
					{
						target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
					},
				],
			},
		},
		TAX_FILING_HISTORY_DETAILS: {
			entry: [
				assign({
					exemptionsProgress: context => (9.5 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "TAX_FILING_HISTORY",
					actions: assign({
						specialFieldsValue: ({ context, event }) => {
							const tax_history_item = {
								...context.specialFieldsValue?.income_tax_history?.[0],
								owner1: {
									...context.specialFieldsValue?.income_tax_history?.[0]
										?.owner1,
									gross_income: undefined,
									filing_status: undefined,
								},
							};
							return {
								...context.specialFieldsValue,
								income_tax_history: [tax_history_item],
							};
						},
					}),
				},
				next: {
					target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
				},
			},
		},
		TAX_FILING_HISTORY_NY_LAST_5_YEARS: {
			entry: [
				assign({
					exemptionsProgress: context => (9.75 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "TAX_FILING_HISTORY_DETAILS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue?.income_tax_history?.[0]?.owner1
								?.federal_tax_return,
						actions: assign({
							specialFieldsValue: ({ context, event }) => {
								return {
									...context.specialFieldsValue,
									filed_ny_state_tax_return_within_last_5_years: undefined,
								};
							},
						}),
					},
					{
						target: "TAX_FILING_HISTORY",
						actions: assign({
							specialFieldsValue: ({ context, event }) => {
								return {
									...context.specialFieldsValue,
									filed_ny_state_tax_return_within_last_5_years: undefined,
								};
							},
						}),
					},
				],
				next: [
					{
						target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue
								?.filed_ny_state_tax_return_within_last_5_years,
					},
					{
						target: "OWNERS",
					},
				],
			},
		},
		TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS: {
			entry: [
				assign({
					exemptionsProgress: context => (9.85 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
					actions: assign({
						specialFieldsValue: ({ context, event }) => {
							return {
								...context.specialFieldsValue,
								most_recent_ny_state_tax_return: undefined,
							};
						},
					}),
				},
				next: {
					target: "OWNERS",
				},
			},
		},
		OWNERS: {
			entry: [
				assign({
					exemptionsProgress: context => (10 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS",
						guard: ({ context, event }) =>
							!!context.specialFieldsValue
								?.filed_ny_state_tax_return_within_last_5_years,
						actions: assign({
							ownersValue: context => undefined,
						}),
					},
					{
						target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
						actions: assign({
							ownersValue: context => undefined,
						}),
					},
				],
				next: [
					{
						target: "ADDITIONAL_OWNER",
						guard: ({ context, event }) =>
							["Own With Spouse", "Other Persons"].includes(
								context.ownersValue ?? ""
							) ||
							(context.maritalStatusValue === "Married" &&
								context.ownersValue === "Sole Owner"),
					},
					{
						target: "TRUST_DOCUMENT_UPLOAD",
						guard: ({ context, event }) =>
							context.specialFieldsValue?.owned_by_trust === true &&
							!context.specialFieldsValue?.trust_document_ref,
					},
					{
						target: "AGREEMENT",
					},
				],
			},
		},
		ADDITIONAL_OWNER: {
			entry: [
				assign({
					exemptionsProgress: context => (10.25 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "OWNERS",
					actions: assign({
						additionalOwnerFirstNameValue: context => undefined,
						additionalOwnerLastNameValue: context => undefined,
						additionalOwnerDobValue: context => undefined,
						owner2SsnTin: context => undefined,
					}),
				},
				next: {
					target: "TAX_FILING_HISTORY_2",
				},
			},
		},
		TAX_FILING_HISTORY_2: {
			entry: [
				assign({
					exemptionsProgress: context => (10.5 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "ADDITIONAL_OWNER",
					actions: assign({
						specialFieldsValue: ({ context, event }) => {
							const tax_history_item = {
								...context.specialFieldsValue?.income_tax_history?.[0],
								owner2: {
									filed: undefined,
									state: undefined,
									gross_income: undefined,
									filing_status: undefined,
								},
							};
							return {
								...context.specialFieldsValue,
								income_tax_history: [tax_history_item],
							};
						},
					}),
				},
				next: [
					{
						target: "TAX_FILING_HISTORY_DETAILS_2",
						guard: ({ context, event }) =>
							["Federal Only", "State Only", "Both Federal and State"].includes(
								context.specialFieldsValue?.income_tax_history?.[0]?.owner2
									?.tax_return_type ?? ""
							),
					},
					{
						target: "TRUST_DOCUMENT_UPLOAD",
						guard: ({ context, event }) =>
							context.specialFieldsValue?.owned_by_trust === true &&
							!context.specialFieldsValue?.trust_document_ref,
					},
					{
						target: "AGREEMENT",
					},
				],
			},
		},
		TAX_FILING_HISTORY_DETAILS_2: {
			entry: [
				assign({
					exemptionsProgress: context => (10.75 / 14) * 100,
				}),
			],
			on: {
				back: {
					target: "TAX_FILING_HISTORY_2",
					actions: assign({
						specialFieldsValue: ({ context, event }) => {
							const tax_history_item = {
								...context.specialFieldsValue?.income_tax_history?.[0],
								owner2: {
									...context.specialFieldsValue?.income_tax_history?.[0]
										?.owner2,
									gross_income: undefined,
									filing_status: undefined,
								},
							};
							return {
								...context.specialFieldsValue,
								income_tax_history: [tax_history_item],
							};
						},
					}),
				},
				next: [
					{
						target: "TRUST_DOCUMENT_UPLOAD",
						guard: ({ context, event }) =>
							context.specialFieldsValue?.owned_by_trust === true &&
							!context.specialFieldsValue?.trust_document_ref,
					},
					{
						target: "AGREEMENT",
					},
				],
			},
		},
		TRUST_DOCUMENT_UPLOAD: {
			entry: [
				assign({
					exemptionsProgress: context => (11 / 14) * 100,
				}),
			],
			on: {
				back: [
					{
						target: "OWNERS",
						guard: ({ context, event }) =>
							commonGuards.isSoleOwner(context) &&
							context.maritalStatusValue === "Single",
					},
					{
						target: "TAX_FILING_HISTORY_DETAILS_2",
						guard: ({ context, event }) =>
							["Federal Only", "State Only", "Both Federal and State"].includes(
								context.specialFieldsValue?.income_tax_history?.[0]?.owner2
									?.tax_return_type ?? ""
							),
					},
					{
						target: "TAX_FILING_HISTORY_2",
					},
				],
				next: {
					target: "AGREEMENT",
				},
			},
		},
		AGREEMENT: {
			entry: [
				assign({
					exemptionsProgress: context => (13 / 14) * 100,
				}),
			],
			on: {
				back: [
					// {
					// 	target: "TRANSFER_STAR_CREDIT",
					// 	cond: context =>
					// 		context?.specialFieldsValue?.transfer_star_credit !==
					// 			undefined && !newYorkGuards.isTransferringStarCredit(context),
					// },
					{
						target: "TRUST_DOCUMENT_UPLOAD",
						guard: ({ context, event }) =>
							context.specialFieldsValue?.owned_by_trust === true &&
							!context.specialFieldsValue?.trust_document_ref,
					},
					{
						target: "OWNERS",
						guard: ({ context, event }) =>
							commonGuards.isSoleOwner(context) &&
							context.maritalStatusValue === "Single",
					},
					{
						target: "TAX_FILING_HISTORY_DETAILS_2",
						guard: ({ context, event }) =>
							["Federal Only", "State Only", "Both Federal and State"].includes(
								context.specialFieldsValue?.income_tax_history?.[0]?.owner2
									?.tax_return_type ?? ""
							),
					},
					{
						target: "TAX_FILING_HISTORY_2",
					},
				],
				next: {
					target: "MAIN_CONFIRMATION",
				},
			},
		},
		MAIN_CONFIRMATION: {
			entry: [
				assign({
					exemptionsProgress: context => 100,
				}),
			],
			on: {
				next: {
					target: "MAIN_CONFIRMATION",
				},
			},
		},
		NY_TAX_NAR: {
			initial: "TAX_FILING_HISTORY",
			states: {
				TAX_FILING_HISTORY: {
					entry: [
						assign({
							exemptionsProgress: context => (0 / 4) * 100,
						}),
					],
					on: {
						next: [
							{
								target: "TAX_FILING_HISTORY_DETAILS",
								guard: ({ context, event }) =>
									!!context.specialFieldsValue?.income_tax_history?.[0]?.owner1
										?.federal_tax_return,
							},
							{
								target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
							},
						],
					},
				},
				TAX_FILING_HISTORY_DETAILS: {
					entry: [
						assign({
							exemptionsProgress: context => (1 / 4) * 100,
						}),
					],
					on: {
						back: {
							target: "TAX_FILING_HISTORY",
							actions: assign({
								specialFieldsValue: ({ context, event }) => {
									const tax_history_item = {
										...context.specialFieldsValue?.income_tax_history?.[0],
										owner1: {
											...context.specialFieldsValue?.income_tax_history?.[0]
												?.owner1,
											gross_income: undefined,
											filing_status: undefined,
										},
									};
									return {
										...context.specialFieldsValue,
										income_tax_history: [tax_history_item],
									};
								},
							}),
						},
						next: {
							target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
						},
					},
				},
				TAX_FILING_HISTORY_NY_LAST_5_YEARS: {
					entry: [
						assign({
							exemptionsProgress: context => (2 / 4) * 100,
						}),
					],
					on: {
						back: [
							{
								target: "TAX_FILING_HISTORY_DETAILS",
								guard: ({ context, event }) =>
									!!context.specialFieldsValue?.income_tax_history?.[0]?.owner1
										?.federal_tax_return,
								actions: assign({
									specialFieldsValue: ({ context, event }) => {
										return {
											...context.specialFieldsValue,
											filed_ny_state_tax_return_within_last_5_years: undefined,
										};
									},
								}),
							},
							{
								target: "TAX_FILING_HISTORY",
								actions: assign({
									specialFieldsValue: ({ context, event }) => {
										return {
											...context.specialFieldsValue,
											filed_ny_state_tax_return_within_last_5_years: undefined,
										};
									},
								}),
							},
						],
						next: [
							{
								target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS",
								guard: ({ context, event }) =>
									!!context.specialFieldsValue
										?.filed_ny_state_tax_return_within_last_5_years,
							},
							{
								target: "NAR_RESOLVED",
							},
						],
					},
				},
				TAX_FILING_HISTORY_NY_LAST_5_YEARS_DETAILS: {
					entry: [
						assign({
							exemptionsProgress: context => (3 / 4) * 100,
						}),
					],
					on: {
						back: {
							target: "TAX_FILING_HISTORY_NY_LAST_5_YEARS",
							actions: assign({
								specialFieldsValue: ({ context, event }) => {
									return {
										...context.specialFieldsValue,
										most_recent_ny_state_tax_return: undefined,
									};
								},
							}),
						},
						next: {
							target: "NAR_RESOLVED",
						},
					},
				},
				NAR_RESOLVED: {
					entry: [
						assign({
							exemptionsProgress: context => (4 / 4) * 100,
						}),
					],
				},
			},
		},
		NY_INVALID_CREDENTIALS_NAR: {
			initial: "PORTAL_ACCOUNT_CREDENTIALS",
			states: {
				PORTAL_ACCOUNT_CREDENTIALS: {
					entry: [
						assign({
							exemptionsProgress: context => 0,
						}),
					],
					on: {
						next: [
							{
								target: "NAR_RESOLVED",
							},
						],
					},
				},
				NAR_RESOLVED: {
					entry: [
						assign({
							exemptionsProgress: context => 100,
						}),
					],
				},
			},
		},
	},
	on: {
		update_context: {
			actions: "updateContext",
		},
		restart: {
			target: ".INIT",
		},
		ny_tax_nar: {
			target: ".NY_TAX_NAR",
		},
		ny_invalid_credentials_nar: {
			target: ".NY_INVALID_CREDENTIALS_NAR",
		},
	},
});
